import styled from '@emotion/styled';
import type { MaterialSymbolOptions } from 'storybookConfig/mixins/materialSymbol';
import materialSymbol from 'storybookConfig/mixins/materialSymbol';
import Button from 'storybookConfig/stories/molecules/Button';

/**
 * Composes an icon as a button.
 */
const IconButton = styled(Button, {
  shouldForwardProp: (prop) => !['additionalStyling'].includes(prop),
})<MaterialSymbolOptions>`
  ${(options) => materialSymbol(options)};
`;

export default IconButton;
